import React from 'react';
import t from 'react-translate';
import moment from 'moment-timezone';
import { Dropdown } from 'react-bootstrap';

import { Timezone } from 'live_sessions/components/use-timezones';
import { getFormattedOffset } from '.';

type TimezoneSelectorItemProps = {
  timezone: Timezone;
  onClick?: (newValue: Timezone) => void;
  disabled?: boolean;
};

const TimezoneSelectorItem = (props: TimezoneSelectorItemProps) => {
  const { timezone, disabled = false, onClick } = props;
  const { shortName, longName, translationKey } = timezone;

  const onItemClick = (tz: Timezone) => {
    onClick?.(tz);
  };

  return (
    <Dropdown.Item
      as='button'
      className='drop-item d-flex flex-column py-1 px-3 text-regular'
      onClick={() => onItemClick(timezone)}
      disabled={disabled}
    >
      <div className='d-flex justify-content-between pr-3 font-weight-bolder w-100'>
        <span>
          {t.TIMEZONE[translationKey]?.() || shortName}
        </span>
        <span className='text-nowrap'>
          {moment.tz(longName).format('hh:mm A')}
        </span>
      </div>
      <span>{`${getFormattedOffset(timezone)} - ${longName}`}</span>
    </Dropdown.Item>
  );
};

export default TimezoneSelectorItem;

